import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  static values = {
    filter: { type: String, default: "tags" },
    selectedList: { type: String, default: "" },
    hiddenIdsSelector: { type: String, default: "" },
  }

  static targets = [
    "container", // e.g. #screen-container, #options-container
    "search", // filter input; Enter does not submit the form
    "selectAll",
    "deselectAll",
  ]

  connect() {
    this._onContainerChange = (e) => {
      if (e.target && e.target.matches("input[type='checkbox']")) {
        this.sync()
      }
    }
    if (this.hasContainerTarget) {
      this.containerTarget.addEventListener("change", this._onContainerChange)
    }
    this.sync()
    this.updateActionLabels(!!(this.hasSearchTarget && this.searchTarget.value && this.searchTarget.value.trim()))

    if (typeof window.Multiset === "undefined") {
      console.warn("multiset-screen-filter: window.Multiset is not loaded")
    }
  }

  disconnect() {
    if (this.hasContainerTarget) {
      this.containerTarget.removeEventListener("change", this._onContainerChange)
    }
  }

  get tagContainerSelector() {
    if (this.hasContainerTarget && this.containerTarget.id) {
      return `#${this.containerTarget.id}`
    }
    console.error("multiset-screen-filter: container target must have an id")
    return null
  }

  onSearchKeydown(e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault()
    }
  }

  filter() {
    if (!this.hasSearchTarget) return
    if (!this.tagContainerSelector) return
    if (typeof window.Multiset === "undefined") return
    const q = this.searchTarget.value || ""
    if (this.filterValue === "name") {
      window.Multiset.filterName(this.tagContainerSelector, q)
    } else {
      window.Multiset.filterTags(this.tagContainerSelector, q)
    }
    this.updateActionLabels(!!(q && q.trim().length > 0))
    this.sync()
  }

  selectAll(e) {
    e?.preventDefault()
    if (!this.tagContainerSelector) return
    if (typeof window.Multiset === "undefined") return
    window.Multiset.toggleCheckAll(this.tagContainerSelector, true)
    this.sync()
  }

  deselectAll(e) {
    e?.preventDefault()
    if (!this.tagContainerSelector) return
    if (typeof window.Multiset === "undefined") return
    window.Multiset.toggleCheckAll(this.tagContainerSelector, false)
    this.sync()
  }

  sync() {
    if (!this.hasContainerTarget) return
    this.syncHiddenIdsFields()
    if (typeof window.Multiset === "undefined") return
    if (!this.tagContainerSelector) return
    if (!this.selectedListValue) return
    if (!document.querySelector(this.selectedListValue)) return
    window.Multiset.updateSelected(this.tagContainerSelector, this.selectedListValue)
  }

  syncHiddenIdsFields() {
    const fieldSelector = (this.hiddenIdsSelectorValue || "").trim()
    if (!fieldSelector) return

    const checkedIds = []
    this.containerTarget.querySelectorAll("input[type='checkbox']").forEach((input) => {
      if (input.checked) checkedIds.push(input.value)
    })
    const serialized = checkedIds.join(",")
    document.querySelectorAll(fieldSelector).forEach((el) => {
      el.value = serialized
    })
  }

  updateActionLabels(filtering) {
    this.applyLinkLabels(this.hasSelectAllTarget && this.selectAllTarget, filtering)
    this.applyLinkLabels(this.hasDeselectAllTarget && this.deselectAllTarget, filtering)
  }

  applyLinkLabels(link, filtering) {
    if (!link) return
    const all = link.dataset.labelAll
    const filtered = link.dataset.labelFiltered
    if (all || filtered) {
      link.textContent = filtering
        ? (filtered || "Select/Deselect (filtered)")
        : (all || "Select/Deselect")
    } else {
      // Legacy English labels when i18n data is not present
      const isDeselect = link === this.deselectAllTarget
      if (isDeselect) {
        link.textContent = filtering ? "Deselect Filtered" : "Deselect All"
      } else {
        link.textContent = filtering ? "Select Filtered" : "Select All"
      }
    }
  }
}